/* Adapt PDP "Sound familiar?" section — v2 (2026-10-05 fix pass). No scroll listeners: every effect fires once from an IntersectionObserver, and nothing here changes element sizes. Loaded with defer by sections/pdp-image-benefits.liquid. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-sf]').forEach(function(root){
    root.classList.add('has-js');

    function onView(el, cb, th){
      if(!el) return;
      if(!('IntersectionObserver' in window)){ cb(); return; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ io.disconnect(); cb(); }
        });
      }, { threshold: th || 0.3 });
      io.observe(el);
    }

    // Heading: words light up one after another once the heading is on screen (stagger lives in CSS).
    var head = root.querySelector('[data-sf-head]');
    if(head){
      onView(head, function(){ head.classList.add('is-in'); }, 0.25);
      setTimeout(function(){ head.classList.add('is-in'); }, 4000);
    }

    // Tick-list.
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-sf-row]'));
    var result = root.querySelector('[data-sf-result]');
    var tally = root.querySelector('[data-sf-tally]');
    var touched = false;

    function sync(){
      var n = rows.filter(function(r){ return r.classList.contains('is-on'); }).length;
      if(result) result.classList.toggle('is-on', n > 0);
      if(tally) tally.textContent = 'You ticked ' + n + ' of ' + rows.length;
    }
    function setRow(r, on){
      r.classList.toggle('is-on', on);
      r.setAttribute('aria-checked', on ? 'true' : 'false');
    }
    rows.forEach(function(r){
      r.addEventListener('click', function(){
        touched = true;
        setRow(r, !r.classList.contains('is-on'));
        sync();
      });
    });
    sync();

    // Two rows tick themselves once the list is on screen (colour only, no size change), unless the visitor already touched it.
    onView(root.querySelector('[data-sf-list]'), function(){
      [0, 2].forEach(function(idx, k){
        if(!rows[idx]) return;
        setTimeout(function(){
          if(touched) return;
          setRow(rows[idx], true);
          sync();
        }, reduce ? 0 : 500 + k * 600);
      });
    }, 0.4);

    // Count-up. A hidden ghost copy of the final number holds the width, so the text beside it never shifts.
    var num = root.querySelector('[data-sf-count]');
    if(num){
      var target = parseInt((num.getAttribute('data-sf-target') || '').replace(/[^0-9]/g, ''), 10);
      if(target > 0 && !reduce){
        num.textContent = '0';
        onView(num, function(){
          var start = null, dur = 1400;
          function step(ts){
            if(start === null) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var eased = 1 - Math.pow(1 - p, 3);
            num.textContent = Math.round(target * eased).toLocaleString('en-US');
            if(p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        }, 0.6);
        setTimeout(function(){ if(num.textContent === '0') num.textContent = target.toLocaleString('en-US'); }, 9000);
      }
    }
  });
})();